<template>
    <div class="personal">
        <public1></public1>
        <div class="personal-content right-content">
            <div class="perheader">
                <perheader></perheader>
            </div>
            <div class="table-content">
                <div class="above">
                    <div class="row">
                        <div class="row1">公寓名称</div>
                        <div class="row2">{{userinfo.Nick}}</div>
                        <el-button class="row3" size="medium" type="primary" @click="modifynick">修改</el-button>
                    </div>
                    <div class="row">
                        <div class="row1">登录账号</div>
                        <div class="row2">{{userinfo.Userid}}</div>
                        <div class="row3"></div>
                    </div>
                    <div class="row">
                        <div class="row1">手机号码</div>
                        <div class="row2">{{userinfo.Phone}}</div>
                        <el-button class="row3" size="medium" type="primary" @click="modifyphone" disabled>修改</el-button>
                    </div>
                    <div class="row">
                        <div class="row1" style="letter-spacing:0.3rem;">邮箱</div>
                        <div class="row2">{{userinfo.Email}}</div>
                        <el-button class="row3" size="medium" type="primary" @click="modifyemail">修改</el-button>
                    </div>
                    <!--<div class="row">-->
                        <!--<div class="row1">登录密码</div>-->
                        <!--<div class="row2">{{userinfo.Pass}}</div>-->
                        <!--<el-button class="row3" size="medium" type="info">重置</el-button>-->
                    <!--</div>-->
                    <div class="row">
                        <div class="row1">注册时间</div>
                        <div class="row2">{{String(userinfo.Addtime).substring(0, 10)}}</div>
                        <div class="row3"></div>
                        <!--<el-button class="row3" size="medium" type="danger" disabled>注销</el-button>-->
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    import public1 from '@/views/public1.vue'
    import perheader from '@/components/perheader.vue'

    export default {
        name: "personal",
        components: {
            public1,
            perheader,
        },
        data() {
            return {
                userinfo:{},


            }
        },

        mounted: function() {
            this.$http.get(`${store.state.url}zone/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                .then((res) => {
                    if (res.Code == 0) {
                        window.console.log(res)
                        this.userinfo=res.Data;
                    } else {
                        this.$message(res.Message);
                    }
                })
        },

        methods:{
            modifynick(){
                this.$prompt('请输入昵称', '修改昵称', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.$http({
                        method: 'put',
                        url: `${store.state.url}user?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                        data: {
                            nick: value,
                            uuid:window.localStorage.uid,
                            userid:window.localStorage.userid,
                        }
                    })
                        .then((res) => {
                            if (res.Code == 0) {
                                this.$message('修改成功');
                                this.userinfo.Nick = value;
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            modifyemail(){
                this.$prompt('请输入邮箱', '修改邮箱', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                    inputErrorMessage: '邮箱格式不正确'
                }).then(({ value }) => {
                    this.$http({
                        method: 'put',
                        url: `${store.state.url}user?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                        data: {
                            uuid:window.localStorage.uid,
                            userid:window.localStorage.userid,
                            email: value,
                        }
                    })
                        .then((res) => {
                            this.$message('修改成功');
                            this.userinfo.Email = value;
                        })
                        .catch((err) => {
                            this.$message(err.Message);
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            modifyphone(){
                this.$prompt('请输入手机号', '修改手机号', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                    inputErrorMessage: '手机号格式不正确'
                }).then(({ value }) => {
                    this.$http({
                        method: 'put',
                        url: `${store.state.url}user?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                        data: {
                            uuid:window.localStorage.uid,
                            userid:window.localStorage.userid,
                            phone: value,
                        }
                    })
                        .then((res) => {
                            this.$message('修改成功');
                            this.userinfo.Phone = value;
                        })
                        .catch((err) => {
                            this.$message(err.Message);
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },




        }
    }
</script>

<style scoped>
    .personal{
        height:100%;
    }
    .personal-content {
        margin: 4vh 3vw;
    }

    .table-content {
        width: 90%;
        height: 50%;
        border: 1px solid #cecece;
        margin-top: 5vh;
        margin-left: 2%;
        display: flex;
        flex-direction:column;
        font-size: 16px;
        padding: 0.3rem;
        padding-top:1vh;
    }

    .above {
        /*height: 60%;*/
        width:100%;
    }
    .below{
        height: 40%;
        width:100%;
    }
    .row{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin:0.2rem auto;
    }
    .row1{
        width:15%;
    }
    .row2{
        width:30%;
    }
    .row3{
        width:8%;
    }


</style>
